(function () {
  function ready(fn) {
    if (document.readyState !== "loading") fn();
    else document.addEventListener("DOMContentLoaded", fn);
  }

  ready(function () {
    var popupOuter = document.querySelector(".pop-up-outer");
    var popupMini = document.querySelector(".pop-up-mini");
    if (!popupOuter || !popupMini) return;

    var STORAGE_KEY = "opuola_popup_seen";
    var MINI_KEY = "opuola_popup_minimized";
    var DISABLED_KEY = "opuola_popup_disabled";

    var closer = popupOuter.querySelector(".pop-up-closer, [aria-label='Fermer'], [aria-label='Close']");
    var overlay = popupOuter.querySelector(".pop-up-bg");

    var miniTrigger = document.querySelector(".pop-up-mini-trigger");
    var miniClose = document.querySelector(".pop-up-mini-close");

    function showMiniButton() {
      popupMini.classList.add("is-visible");
    }

    function hideMiniButton() {
      popupMini.classList.remove("is-visible");
    }

    function openPopup() {
      popupOuter.classList.add("active");
      popupOuter.setAttribute("aria-hidden", "false");
      document.body.classList.add("popup-open");
      hideMiniButton();
    }

    function closePopupToMini() {
      popupOuter.classList.remove("active");
      popupOuter.setAttribute("aria-hidden", "true");
      document.body.classList.remove("popup-open");

      localStorage.setItem(STORAGE_KEY, "1");
      localStorage.setItem(MINI_KEY, "1");
      showMiniButton();
    }

    function disableMiniAndPopup() {
      popupOuter.classList.remove("active");
      popupOuter.setAttribute("aria-hidden", "true");
      document.body.classList.remove("popup-open");

      hideMiniButton();

      localStorage.setItem(STORAGE_KEY, "1");
      localStorage.setItem(MINI_KEY, "0");
      localStorage.setItem(DISABLED_KEY, "1");
    }

    // Si l’utilisateur a “désactivé” le teaser, on ne montre rien
    if (localStorage.getItem(DISABLED_KEY) === "1") return;

    // Si déjà minimisé, on montre le mini immédiatement
    if (localStorage.getItem(MINI_KEY) === "1") {
      showMiniButton();
    }

    // Pop-up après 5s uniquement si jamais vu et pas minimisé
    if (localStorage.getItem(STORAGE_KEY) !== "1" && localStorage.getItem(MINI_KEY) !== "1") {
      setTimeout(openPopup, 5000);
    }

    // Fermeture pop-up -> mini
    if (closer) closer.addEventListener("click", closePopupToMini);
    if (overlay) overlay.addEventListener("click", closePopupToMini);

    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && popupOuter.classList.contains("active")) {
        closePopupToMini();
      }
    });

    // Click mini -> ouvre pop-up
    if (miniTrigger) {
      miniTrigger.addEventListener("click", function (e) {
        e.preventDefault();
        openPopup();
      });
    } else {
      // fallback si tu cliques sur le container
      popupMini.addEventListener("click", function () {
        openPopup();
      });
    }

    // Croix mini -> ferme tout (mini + popup)
    if (miniClose) {
      miniClose.addEventListener("click", function (e) {
        e.stopPropagation();
        disableMiniAndPopup();
      });
    }
  });
})();
